import React, { ReactNode } from 'react'
// import { View } from 'react-native'
import tw from 'tailwind-rn'
import { HGGroup, HGText } from '../HGUI'
import HGModalFull from './HGModalFull'

type Props = {
  visible: boolean
  title?: ReactNode | string
  content?: ReactNode | string
  onClose: (success: boolean) => void
}

export default function Alert(props: Props) {
  const { visible, title, content, onClose } = props

  if (!visible) return null

  return (
    <HGModalFull
      {...props}
      onRequestClose={() => {}}
      style={tw('flex-1 fixed top-0 bg-red-50 w-full')}
      // style={{ backgroundColor: colors.beige, flex: 1 }}
    >
      <HGGroup transparentMode>
        {title && <HGText>{title}</HGText>}

        {content}
      </HGGroup>
    </HGModalFull>
  )
}

Alert.defaultProps = {
  title: null,
  content: null,
}
